<!--
 * @Description:
 * @Author: yangsibo
 * @Date: 2023-09-19 18:12:43
 * @LastEditors: yangsibo
 * @LastEditTime: 2024-07-26 16:37:07
 * @FilePath: /adm.xiangli360.com/src/App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss">
html,
body {
  overflow: hidden;
}
#app {
  height: 100vh;
}
</style>
